import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import SelectBox from '../../../components/elements/form/selectBox';
import Button from '../../../components/elements/button';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import Icon from '../../../components/icons';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import Loader from '../../../components/loader';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    onSelect: (assets:any[]) => void
    onCancel?: () => void
    selected?: any
    searchfacility?: any;
    searchsubFacility?: any;
}



const FindAssetsModal: React.FC<Props> = ({ _ref, onSelect, onCancel = () => { }, selected, searchfacility,  searchsubFacility}) => {

    const facilityApi: any = useFacilitiesApi();
    const assetsAPI: any = useAssetsApi();
    const [facilities, setFacilities] = useState<any>([]);

    const [facility, setFacility] = useState<any>(null);
    const [subFacility, setSubFacility] = useState<any>(null);

    const [assetSearchKey, setAssetSearchKey] = useState<string>('');
    const [working, setWorking] = useState<boolean>(false);
    const [assets, setAssets] = useState<any>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedAssets, setSelectedAssets] = useState<any>([]);

    const {  handleSubmit} = useForm<any>();

    const colse = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        resetForm();
        _ref?.current?.close()
        onCancel()
    }

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                const facilitylist = resp.facilityList?.map((facilist: any) => {
                    return {
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                    }
                });
                setFacilities(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        )
    };

    const getAssetsList = () => {
        setAssets([]);
        setWorking(true);
        let payload: any = {statusIDs: [1, 2, 3, 4, 5, 6].join(`,`)};
        if(assetSearchKey !== '') {
            payload.searchParam = assetSearchKey;
        }
        if (facility) {
            payload.facilityIDs = [facility.value];
        }
        
        if (subFacility) {
            payload.subFacilityIDs = [subFacility.value];
        }
        
        
        assetsAPI.getAssetsList(payload, (data: any) => {
            setWorking(false);
            setAssets(data.assetList ? data.assetList : []);
        }, (error: any) => { setWorking(false) });
    };

    const onSubmit = (data: any) => {
        onSelect(selectedAssets);
        _ref?.current?.close();
        resetForm();
    }

    const resetForm = () => {
        setAssetSearchKey('');
        setAssets([]);
        setFacility(null);
    }


    useEffect(() => {
        if(assetSearchKey !== '') {
            const debounceTimeout = setTimeout(() => {
                getAssetsList();
            }, 500);
            return () => clearTimeout(debounceTimeout);
        }
    }, [assetSearchKey])

    useEffect(() => {
        getfacilitylist();
    }, [])

    useEffect(() => {
        getAssetsList();
    }, [facility])

    const onOpen = () => {
        console.log('Modal opened', selected);
        //setSelectedAssets(selected ? selected : []);
        getAssetsList()
    }

    useEffect(() => {
        setSelectedAssets(selected ? selected : []);
    }, [selected]);

    useEffect(() => {
        if (_ref.current) {
            const modal: any = _ref.current;
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (
                        mutation.type === "attributes" &&
                        mutation.attributeName === "open"
                    ) {
                        
                        if (_ref.current?.hasAttribute("open")) {
                            onOpen();
                            setIsOpen(true);
                        } else {
                            setIsOpen(false);
                        }
                    }
                }
            });
            if (modal) observer.observe(modal, { attributes: true });
            return () => observer.disconnect();
        }
    }, [_ref]);


    return (
        <dialog ref={_ref} className="modal">        
            <div className="modal-box max-w-[90%] w-[50rem] p-4">
                <div >

                    <div className='flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>Find Asset</p>
                        <button onClick={colse} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3'>
                        <SelectBox
                            label='Select Sub  Facility type'
                            required
                            value={facility}
                            onChange={setFacility}
                            placeholder='Choose Processing Facility'
                            options={facilities}
                            isClearable
                            
                        />

                        <Input
                            className="!my-0"
                            type="text"
                            value={assetSearchKey}
                            onChange={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setAssetSearchKey(e.target.value)
                            }}
                            placeholder="Enter Asset Code or Name"
                        />

                        {selectedAssets.length > 0 && 
                        <div className=''>
                            <p className='font-medium text-[14px] mt-3'>Selected Assets</p>
                            <div className="rounded-md border border-gray-300 mt-1">
                                <div className='grid grid-cols-12 gap-1 bg-gray-100'>
                                    <div className='col-span-1 px-2 leading-10 '>
                                        <label className='text-[0.75rem] font-medium text-slate-600'></label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10 '>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Asset Code</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Asset Name</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Category</label>
                                    </div>
                                    <div className='col-span-5 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Facility</label>
                                    </div>
                                    
                                </div>
                            

                                {selectedAssets.length > 0 ? (
                                    selectedAssets.map((asset: any, index: number) => (
                                        <div className='grid grid-cols-12 gap-1 text-slate-800' key={asset.assetID}>
                                            <div className='col-span-1 px-2 leading-10 flex items-center'>
                                                <input 
                                                    type="checkbox"
                                                    className='checkbox checkbox-sm checkbox-primary'
                                                    checked={selectedAssets.map((a:any)=>a.assetID).includes(asset.assetID)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSelectedAssets([...selectedAssets, asset]);
                                                        } else {
                                                            console.log('Unchecking asset:', asset);
                                                            setSelectedAssets(selectedAssets.filter((_asset: any) => _asset.assetID !== asset.assetID));
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                <p className='font-medium text-[0.75rem]'>{asset.assetCode}</p>
                                            </div>
                                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                <label className='text-[0.75rem] font-normal leading-[1.2]'>{asset.name}</label>
                                            </div>
                                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                <label className='text-[0.75rem] font-normal w-full'>{asset.categoryName}</label>
                                            </div>
                                            <div className='col-span-5 px-2 leading-10 flex items-center'>
                                                <label className='text-[0.75rem] font-normal w-full'>{asset.facilityName}</label>
                                            </div>
                                        
                                        </div>
                                    ))
                                ) : (
                                    <div className='flex items-center justify-center py-10'>
                                        <p className='text-slate-500'>No assets found</p>
                                    </div>
                                )}



                            </div>
                        </div>
                        }


                        <div className='min-h-[300px]'>
                            <p className='font-medium text-[14px] mt-3'>Add more Assets</p>
                            <div className="rounded-md border border-gray-300 mt-1">
                                <div className='grid grid-cols-12 gap-1 bg-gray-100'>
                                    <div className='col-span-1 px-2 leading-10 '>
                                        <label className='text-[0.75rem] font-medium text-slate-600'></label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10 '>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Asset Code</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Asset Name</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Category</label>
                                    </div>
                                    <div className='col-span-5 px-2 leading-10'>
                                        <label className='text-[0.75rem] font-medium text-slate-600'>Facility</label>
                                    </div>
                                    
                                </div>
                                {working && (
                                    <div className='flex items-center justify-center py-10'>
                                        <Loader />
                                    </div>
                                )}

                                {assets.length > 0 ? (
                                    assets.map((asset: any, index: number) => {
                                        if (selectedAssets.map((a: any) => a.assetID).includes(asset.assetID)) {
                                            return null; // Skip rendering if asset is already selected
                                        }
                                        return (
                                            <div className='grid grid-cols-12 gap-1 text-slate-800' key={asset.assetID}>
                                                <div className='col-span-1 px-2 leading-10 flex items-center'>
                                                    <input
                                                        type="checkbox"
                                                        className='checkbox checkbox-sm checkbox-primary'
                                                        checked={selectedAssets.map((a: any) => a.assetID).includes(asset.assetID)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedAssets([...selectedAssets, asset]);
                                                            } else {
                                                                setSelectedAssets(selectedAssets.filter((_asset: any) => _asset.id !== asset.assetID));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                    <p className='font-medium text-[0.75rem]'>{asset.assetCode}</p>
                                                </div>
                                                <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                    <label className='text-[0.75rem] font-normal leading-[1.2]'>{asset.name}</label>
                                                </div>
                                                <div className='col-span-2 px-2 leading-10 flex items-center'>
                                                    <label className='text-[0.75rem] font-normal w-full'>{asset.categoryName}</label>
                                                </div>
                                                <div className='col-span-5 px-2 leading-10 flex items-center'>
                                                    <label className='text-[0.75rem] font-normal w-full'>{asset.facilityName}</label>
                                                </div>

                                            </div>
                                        )
                                    })
                                ) : (
                                    <div className='flex items-center justify-center py-10'>
                                        <p className='text-slate-500'>No assets found</p>
                                    </div>
                                )}



                            </div>
                        </div>
                    </div>

                    <div className='flex justify-end gap-2 border-t border-[#8D6E63] pt-2'>
                        <Button type="button" theme='secondary' onClick={colse}>Cancel</Button>
                        <Button type="button" onClick={onSubmit} >Save</Button>
                    </div>

                </div>
            </div>
            <form method="dialog" className="modal-backdrop" onClick={colse}></form>                
        </dialog>
    );
};

export default FindAssetsModal;